import React, { useState, ReactNode, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import axios from 'axios';


interface AuthProviderProps {
    children: ReactNode;
}


export function AuthProvider({ children } : AuthProviderProps) {
    const [token, setToken] = useState<string | undefined>(localStorage.getItem('token')  || undefined);
    axios.defaults.headers.Authorization = token ? "Bearer " + token : "";


    const handleSetToken = (newToken: string | undefined) => {
        if (newToken) {
            localStorage.setItem('token', newToken);
        } else {
            localStorage.removeItem('token');
        }
        setToken(newToken);

    };

    const isAuthenticated = !!token;

    

    return (
        <AuthContext.Provider value={{ setToken: handleSetToken, isAuthenticated }}>
            {children}
        </AuthContext.Provider>
    );
};
